import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import ProvenProcess from './ProvenProcess'
import TechTrends from './TechTrends'
import StaffingDetails from './StaffingDetails'
import HireDevelopers from './HireDevelopers'
import IntroImage from './IntroImage'
import StaffingFAQs from './StaffingDetails'
import ContactForm from '../../component/ReusablaeComponent/ContactMini';
import WhyChooseUs from './Whychoose';
import RecruitmentTechnologies from './RecruitmentTechnologies';
import OurService from './OurService';
import StaffingSolutions from './StaffingSolutions';
import OurImpact from './OurImpact';
import {WhyKapilTech} from './WhyKapilTech';
import HiringProcess from './HiringProcess';
import TalentExpertise from './TalentExpertise';
import {Clients} from './Clients';
import  HeroSection  from './Hero';
import ReadyToHire from './ReadyToHire';


const HomePage = () => {

  return (
    <div>
      <Helmet>
        <title>SAP Staffing Services India | IT Recruitment & Consulting | Kapil Technologies</title>
        <meta name="description" content="Kapil Technologies offers expert SAP staffing, IT recruitment, and consulting services in India. Connect with pre-vetted SAP consultants, developers, and IT professionals for your business growth." />
        <meta name="keywords" content="SAP staffing India, IT recruitment India, SAP consultants India, SAP S/4HANA staffing, ERP implementation India, IT consulting India, SAP recruitment agency, nearshore talent India, SAP developers India, IT staffing solutions, SAP implementation services, technical staffing India, SAP project staffing, IT talent acquisition, Kapil Technologies" />
        <meta name="author" content="Kapil Technologies" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="SAP Staffing Services India | IT Recruitment & Consulting | Kapil Technologies" />
        <meta property="og:description" content="Kapil Technologies offers expert SAP staffing, IT recruitment, and consulting services in India. Connect with pre-vetted SAP consultants, developers, and IT professionals." />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="SAP Staffing Services India | IT Recruitment & Consulting" />
        <meta name="twitter:description" content="Expert SAP staffing and IT recruitment services in India. Connect with pre-vetted professionals for your business growth." />
        <link rel="canonical" href="https://kapiltechnologies.com/" />
      </Helmet>
      <HeroSection/>
      <StaffingSolutions/>
      <WhyKapilTech/>
      <TalentExpertise/>
      <OurImpact/>
      <Clients/>
      <HiringProcess/>
      <ReadyToHire/>
    </div>
  )
}

export default HomePage
